




import {Component, Prop, Vue} from "vue-property-decorator";
import {ProvinceStore} from "@/modules/regionsv2/province/store";

@Component({
    name: "ProvinceLabelV2"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly id!: number;

    get label() {
        const province = ProvinceStore.data[this.id];
        return `${province?.code} - ${province?.name}`;
    }
}
